import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { inputStyles } from "../styles";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    content: {
      width: "100%",
      backgroundColor: theme.white50,
      boxShadow:
        "0px 1px 18px 0px rgba(0, 0, 0, 0.12), 0px 6px 11px 0px rgba(0, 0, 0, 0.14), 0px 3px 7px -1px rgba(0, 0, 0, 0.20)",
    },
    tabsWrapper: {
      padding: theme.spacing(8, 8, 0),
    },
    tabs: {
      margin: 0,
    },
    list: {
      maxHeight: "400px",
      overflowY: "auto",
      paddingTop: 0,
    },
    loader: {
      position: "unset",
    },
    helperText: {
      background: "transparent",
    },
    input: { ...inputStyles },
    inputBase: {
      background: theme.white50,
    },
    noOption: {
      color: theme.gray400,
    },
    item: {
      borderRadius: "8px",
      padding: theme.spacing(4),
    },
    inactiveTier: {
      display: "flex",
      gap: theme.spacing(4),
      color: theme.gray500,
      alignItems: "center",
      marginLeft: theme.spacing(4),
    },
    dot: {
      width: 6,
      minWidth: 6,
      height: 6,
      backgroundColor: theme.gray500,
      borderRadius: "50%",
    },
    wrapper: {
      textWrap: "nowrap",
      overflowX: "auto",
      overflowY: "hidden",
      alignItems: "center",
    },
    tierWrapper: {
      display: "inline-flex",
      alignItems: "center",
      marginRight: theme.spacing(4),
      fontSize: ({ size }: { size?: string }) => (size === "small" ? 15 : 16),
      height: "100%",
    },
    tierSetPill: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      padding: theme.spacing(4, 6),
      backgroundColor: theme.green50,
      color: theme.green800,
      borderRadius: "32px",
      fontSize: 12,
      marginLeft: theme.spacing(4),
      lineHeight: "12px",
    },
    separator: {
      marginRight: theme.spacing(4),
    },
    tierName: {
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  }),
);
